import { h } from 'preact';
import { RoundButtonWrapper } from './RoundButton.styled';

const RoundButton = props => <RoundButtonWrapper {...props} />;

export default RoundButton;
